import logo1 from '../assets/home-courses/home-course1.jpg'
import logo2 from '../assets/home-courses/home-course2.jpg'
import logo3 from '../assets/home-courses/home-course3.jpg'
import logo4 from '../assets/home-courses/home-course4.jpg'


export const HomeData = [{
    banner: logo1,
    title: 'UX & UI Design Courses',
    duration: '6hr 24min',
    viewsCount: '2.6K views',
    data: 'UX based on real world examples. Gain powerful UX skills you can use to start a UX career or improve your projects.',
    list1: 'Gain UX skills you can immediately apply to improve your projects and career',
    list2: 'Learn how to conduct effective and useful research',
    list3: 'Understand how to apply UX Strategy to set goals and define success',
    courseDetails: '12 sections • 156 lectures • 12h 9m total length',
    showPrice: 10000,
},
{
    banner: logo2,
    title: 'Data Science',
    duration: '6hr 24min',
    viewsCount: '2.6K views',
    data: 'UX based on real world examples. Gain powerful UX skills you can use to start a UX career or improve your projects.',
    list1: 'Gain UX skills you can immediately apply to improve your projects and career',
    list2: 'Learn how to conduct effective and useful research',
    list3: 'Understand how to apply UX Strategy to set goals and define success',
    courseDetails: '12 sections • 156 lectures • 12h 9m total length',
    showPrice: 10000,

},
{
    banner: logo3,
    title: 'Digital Marketing/ Advertising',
    duration: '6hr 24min',
    viewsCount: '2.6K views',
    data: 'UX based on real world examples. Gain powerful UX skills you can use to start a UX career or improve your projects.',
    list1: 'Gain UX skills you can immediately apply to improve your projects and career',
    list2: 'Learn how to conduct effective and useful research',
    list3: 'Understand how to apply UX Strategy to set goals and define success',
    courseDetails: '12 sections • 156 lectures • 12h 9m total length',
    showPrice: 10000,
},
{
    banner: logo4,
    title: 'Dropshipping',
    duration: '6hr 24min',
    viewsCount: '2.6K views',
    data: 'UX based on real world examples. Gain powerful UX skills you can use to start a UX career or improve your projects.',
    list1: 'Gain UX skills you can immediately apply to improve your projects and career',
    list2: 'Learn how to conduct effective and useful research',
    list3: 'Understand how to apply UX Strategy to set goals and define success',
    courseDetails: '12 sections • 156 lectures • 12h 9m total length',
    showPrice: 10000,
},
{
    banner: logo1,
    title: 'UX & UI Design Courses',
    duration: '6hr 24min',
    viewsCount: '2.6K views',
    data: 'UX based on real world examples. Gain powerful UX skills you can use to start a UX career or improve your projects.',
    list1: 'Gain UX skills you can immediately apply to improve your projects and career',
    list2: 'Learn how to conduct effective and useful research',
    list3: 'Understand how to apply UX Strategy to set goals and define success',
    courseDetails: '12 sections • 156 lectures • 12h 9m total length',
    showPrice: 10000,
},
] 